import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'


const ParceiroCard = ({ parceiro, idPerfilAcesso, remover, permiteAdicionarAlterarResponsavel }) => {
    
    return (
        <div className={styles.wrapper}>

            {
                (parceiro.regional !== null || parceiro.regional !== "undefined" || parceiro.regional !== "") &&
                <>
                    <div className={styles.title}>
                        Regional:
                    </div>
                    <div className={styles.info}>
                        {parceiro.regional}
                    </div>
                </>
            }

            {
                (parceiro.filial !== null || parceiro.filial !== "undefined" || parceiro.filial !== "") &&
                <>
                    <div className={styles.title}>
                        Filial:
                    </div>
                    <div className={styles.info}>
                        {parceiro.filial}
                    </div>
                </>
            }

            {
                (parceiro.nomeParceiro !== undefined) &&
                <>
                    <div className={styles.title}>
                        Loja:
                    </div>
                    <div className={styles.info}>
                        {parceiro.nomeParceiro}
                    </div>
                </>
            }

{
                (parceiro.codigo !== undefined) &&
                <>
                    <div className={styles.title}>
                        Código Parceiro:
                    </div>
                    <div className={styles.info}>
                        {parceiro.codigo}
                    </div>
                </>
            }

            {
                (permiteAdicionarAlterarResponsavel === undefined || permiteAdicionarAlterarResponsavel) &&
                <button className={styles.apagar} onClick={remover}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            }
        </div>
    )
}

export default ParceiroCard